<div class="duna-user-notification-preferences">
  <h2 class="heading">Notifikationer</h2>
  <p class="explanation">
    Vælg hvilke event-notifikationer du vil modtage som e-mail og/eller push.
    Organisationen kan sætte standarder; når du gemmer her, gælder dine egne valg.
  </p>

  @if (loading) {
  <div class="loading-row">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Henter indstillinger...</span>
  </div>
  } @if (!loading && accessDenied) {
  <p class="error">Du har ikke adgang til at ændre disse indstillinger.</p>
  } @if (!loading && errorMessage) {
  <p class="error">{{ errorMessage }}</p>
  } @if (!loading && !errorMessage && !accessDenied) {
  <div class="pref-table" role="table">
    <div class="pref-header" role="row">
      <span class="pref-label-col" role="columnheader">Notifikation</span>
      <span class="pref-channel-col" role="columnheader">E-mail</span>
      <span class="pref-channel-col" role="columnheader">Push</span>
    </div>
    @for (row of rows; track row.key) {
    <div class="pref-row" role="row">
      <span class="pref-label-col" role="cell">{{ row.label }}</span>
      <span class="pref-channel-col" role="cell">
        <mat-checkbox
          [checked]="isEmailChecked(row.key)"
          (change)="setEmail(row.key, $event.checked)"
          aria-label="E-mail for {{ row.label }}"
        ></mat-checkbox>
      </span>
      <span class="pref-channel-col" role="cell">
        <mat-checkbox
          [checked]="isPushChecked(row.key)"
          (change)="setPush(row.key, $event.checked)"
          aria-label="Push for {{ row.label }}"
        ></mat-checkbox>
      </span>
    </div>
    }
  </div>
  <div class="actions">
    <button
      mat-flat-button
      color="primary"
      (click)="save()"
      [disabled]="saving"
    >
      {{ saving ? 'Gemmer...' : 'Gem notifikationer' }}
    </button>
  </div>
  }
</div>
